import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'RECENT_UPDATE',
    smsDelete : 'RECENT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        recent:[],
      
        recent_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        recentLoading: false,
        recentError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_RECENT(state, recent) {
            state.recent = recent;
        },

        SET_RECENT_DETAIL(state, detail) {
            state.recent_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },


        RECENT_LOADING (state, loading) {
            state.recentLoading = loading;
        },

        RECENT_ERROR (state, hasError) {
            state.recentError = hasError;
        },
        


       
    },

    actions: {
        //Recent
        async addRecent ({commit, dispatch}, payload) {
            commit('RECENT_LOADING', true);
            commit('RECENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_recent, payload.recent, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRecent')
               
                return response

            }catch (e) {
                commit('RECENT_ERROR', true);
            }finally {
                commit('RECENT_LOADING', false);
            }
        },

        async fetchRecentDetail ({ commit },payload) {
            commit('RECENT_LOADING', true);
            commit('RECENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_recent_details + payload, config);
                let response = result.data.data

                commit('SET_RECENT_DETAIL', response);

            } catch(error) {
                commit('RECENT_ERROR', true);
            }
            finally {
                commit('RECENT_LOADING', false);
            }
        },



        async fetchRecent ({ commit }) {
            commit('RECENT_LOADING', true);
            commit('RECENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.recent_list, config);
                let response = result.data

                commit('SET_RECENT', response.data);

            } catch(error) {
                commit('RECENT_ERROR', true);
            }
            finally {
                commit('RECENT_LOADING', false);
            }
        },


    
        async updateRecent ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.update_recent+payload.id, payload.recent, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRecent')
                return response

            }catch (e) {
                commit('RECENT_ERROR', true);
            }finally {
                commit('RECENT_LOADING', false);
            }
        },

        
        async deleteRecent({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.recent_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchRecent')
            
            return response
        },




    },

    getters: {}
}
